// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
/**
 * This enumeration defines gravity level of messages.
 * It reflects values of corresponding C++ `Message_Gravity` enumeration defined by OCCT,
 * and used to redirect message coming from C++ algorithms via [[OccViewer.printMessage]] callback.
 * See also [[OccViewer.traceLevel]] defining which messages should be delivered.
 */
export var Message_Gravity;
(function (Message_Gravity) {
    /** Low-level details on algorithm execution (usually for debug purposes). */
    Message_Gravity[Message_Gravity["Message_Trace"] = 0] = "Message_Trace";
    /** Informative message. */
    Message_Gravity[Message_Gravity["Message_Info"] = 1] = "Message_Info";
    /** Warning message. */
    Message_Gravity[Message_Gravity["Message_Warning"] = 2] = "Message_Warning";
    /** Non-critical error. */
    Message_Gravity[Message_Gravity["Message_Alarm"] = 3] = "Message_Alarm";
    /** Fatal error. */
    Message_Gravity[Message_Gravity["Message_Fail"] = 4] = "Message_Fail";
})(Message_Gravity || (Message_Gravity = {}));
